import { render, staticRenderFns } from "./ServicesDownScreen.vue?vue&type=template&id=0b05e2a7&scoped=true&"
import script from "./ServicesDownScreen.vue?vue&type=script&lang=js&"
export * from "./ServicesDownScreen.vue?vue&type=script&lang=js&"
import style0 from "./ServicesDownScreen.vue?vue&type=style&index=0&id=0b05e2a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b05e2a7",
  null
  
)

export default component.exports